import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import DividaService from '../../../../services/divida';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchDividas()
            setNome("")
        } else {
            var response = await DividaService.buscar(query)
            if (response.data.length >= 1) {
                props.setDividas(response.data)
                props.setVazio(false)
                setNome("")
            } else {
                props.setVazio(true)
                setNome("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `nome=${encodeURI(nome)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={2}>
                        <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Empresa/Pessoa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca